export enum PazaakTableSlots {
  INVALID = -1,
  SLOT_1 = 0,
  SLOT_2 = 1,
  SLOT_3 = 2,
  SLOT_4 = 3,
  SLOT_5 = 4,
  SLOT_6 = 5,
  SLOT_7 = 6,
  SLOT_8 = 7,
  SLOT_9 = 8,
  MAX_SLOTS = 9
}
